export const GITHUB_DATA_GET = 'GITHUB_DATA_GET'
export const GITHUB_DATA_UPDATE = 'GITHUB_DATA_UPDATE'
export const GITHUB_DATA_ERROR = 'GITHUB_DATA_ERROR'

export function getGithubData(payload = {}) {
  return {
    type: GITHUB_DATA_GET,
    payload,
  }
}

export function updateGithubData(payload = {}) {
  return {
    type: GITHUB_DATA_UPDATE,
    payload,
  }
}

export function errorGithubData(payload = {}) {
  return {
    type: GITHUB_DATA_ERROR,
    payload,
  }
}
